import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { notificationContextFromUrl, recordNotificationEngagement } from '@/lib/notificationEngagement';

export default function NotificationEngagementTracker() {
  const { user } = useAuth();
  const location = useLocation();
  useEffect(() => { if (user) void supabase.rpc('touch_notification_activity'); }, [user, location.pathname]);
  useEffect(() => {
    if (!user) return;
    const context = notificationContextFromUrl(location.search);
    void recordNotificationEngagement('destination_reached', context.notificationId, context.proactiveSendId);
  }, [user, location.search]);
  return null;
}